module.exports = __webpack_public_path__ + "img/streaming_dove.6326ef04.svg";